<script context="module" lang="ts">
  export type SortDirection = {
    runnerId: string;
    direction: 'asc' | 'desc' | 'none';
  };
</script>

<script lang="ts">
  import TablerArrowsSort from '~icons/tabler/arrows-sort';
  import TablerSortAscendingNumbers from '~icons/tabler/sort-ascending-numbers';
  import TablerSortDescendingNumbers from '~icons/tabler/sort-descending-numbers';

  export let sortDirection: SortDirection | undefined = undefined;
  export let hovered = false;

  $: isHoveredClass = !hovered ? 'text-gray-800' : 'text-gray-500';
</script>

<div class="w-4 text-gray-400">
  {#if sortDirection?.direction === 'asc'}
    <TablerSortAscendingNumbers class={isHoveredClass} />
  {:else if sortDirection?.direction === 'desc'}
    <TablerSortDescendingNumbers
      class="{isHoveredClass} rotate-180 transform"
    />
  {:else if hovered}
    <TablerArrowsSort />
  {/if}
</div>
